import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { NavItemNames } from '@employer/app/services/navigation.service'
import { FileNotFoundComponent } from '../_404/404.component'
import { AboutComponent } from './about/about.component'
import { HomeComponent } from './home.component'

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'profiles',
        loadChildren: () => import('../resume/resume.module').then(m => m.ResumeModule),
      },
      {
        path: 'resume-parsing',
        loadChildren: () => import('../resume/resume.module').then(m => m.ResumeModule),
      },
      {
        path: 'apply/:jobPostId',
        redirectTo: '/applications/apply/:jobPostId',
        pathMatch: 'full',
      },
      {
        path: 'videos',
        loadChildren: () => import('../videos/videos.module').then(m => m.VideosModule),
      },

      {
        path: 'about',
        component: AboutComponent,
      },
      {
        path: '404',
        component: FileNotFoundComponent,
        data: { title: NavItemNames.FileNotFound },
      },
      {
        path: '',
        redirectTo: 'profiles',
        pathMatch: 'full',
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
